'use strict';

/**
 * Component to display a date range and page though time, based on the length of the inital range set.
 * @param {Function} onSetDateRange    Gets called each time the date changes. Returns the new startDate and endDate
 * @param {Moment} initDate            The initial date to start counting from.
 * @param {Moment.duration} dateRange  A moment range to define the page. Only tested with weeks.
 * @param {Boolean} startOnSunday      Changes the paging mode. Instead of starting with initDate, startOnSunday uses the 
 *                                     first day of the calendar week that initDate fall on. This is probably Sunday, but could be 
 *                                     a different day if the locale calls for it. It has only been tested with Sunday-first locales.
 */

(function () {
  'use strict';

  angular.module('msCore').component('msDatePagingHeader', {
    templateUrl: 'core/templates/ms-date-paging-header.html',
    controller: msDatePagingHeader,
    bindings: {
      onSetDateRange: '&',
      initDate: '<',
      dateRange: '<',
      startOnSunday: '<'
    }
  });

  msDatePagingHeader.$inject = ['$log'];

  function msDatePagingHeader($log) {
    var vm = this;
    vm.$onInit = _activate;

    vm.retreatDateRange = function () {
      vm.endDate = vm.startDate.clone().subtract(1, 'day');
      if (vm.startOnSunday) {
        vm.startDate = vm.endDate.clone().subtract(vm.dateRange).startOf('week');
      } else {
        vm.startDate = vm.endDate.clone().subtract(vm.dateRange).add(1, 'day');
      }

      setViewData();
    };

    vm.advanceDateRange = function () {
      vm.startDate = vm.endDate.clone().add(1, 'day');
      if (vm.startOnSunday) {
        vm.endDate = vm.startDate.clone().add(vm.dateRange).endOf('week');
      } else {
        vm.endDate = vm.startDate.clone().add(vm.dateRange).subtract(1, 'day');
      }

      setViewData();
    };

    function _activate() {
      $log.debug('activate datepagingheader');
      vm.currentDate = vm.initDate.clone();
      if (vm.startOnSunday) {
        vm.startDate = vm.currentDate.clone().subtract(vm.dateRange).startOf('week');
        vm.endDate = vm.currentDate.clone().endOf('week');
      } else {
        vm.startDate = vm.currentDate.clone().subtract(vm.dateRange.get('days') - 1, 'day');
        vm.endDate = vm.currentDate.clone();
      }

      setViewData();
    }

    function setViewData() {
      // Note: This assumes you will not be able to click on today's date.
      // To generalize this component for other uses, this will have to be changed to a binding
      vm.nextDisabled = vm.endDate.isSameOrAfter(moment().subtract(1, 'day'), 'day');
      vm.onSetDateRange({
        startDate: vm.startDate,
        endDate: vm.endDate
      });
    }
  }
})();